import {
    XBrowseProps,
    XLazyColumn,
    XLazyDataTable, XLazyDataTableRef,
    XMultilineRenderType, XSearchBrowseProps
} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import React, {useRef} from "react";
import {VykazStreetworkForm} from "./VykazStreetworkForm";
import {Utils} from "../../Utils";
import {EnumEnum} from "../../common/enums";
import {VykazStreetwork} from "../../model/zapisy/vykaz-streetwork.entity";
import {VykazStreetworkHlavickaForm} from "./VykazStreetworkHlavickaForm";
import {XButton} from "@michalrakus/x-react-web-lib/XButton";
import {XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {XHtmlRenderer} from "@michalrakus/x-react-web-lib/XHtmlRenderer";
import {useXStateSession} from "@michalrakus/x-react-web-lib/useXStateSession";
import {XOnSaveOrCancelProp} from "@michalrakus/x-react-web-lib/XFormBase";
import {XFormColumn} from "@michalrakus/x-react-web-lib/XFormDataTable2";

export const VykazStreetworkBrowse = (props: XBrowseProps & XSearchBrowseProps) => {

    const xLazyDataTableRef = useRef<XLazyDataTableRef>(null);

    const [multilineSwitchValue, setMultilineSwitchValue] = useXStateSession<XMultilineRenderType>(`vykaz-streetwork-browse-multiline-switch-value`, "allLines"); // init value

    const showExpandedRowMobile = (vykazStreetwork: VykazStreetwork, switchValue: XMultilineRenderType): boolean => {
        return switchValue !== "singleLine" && vykazStreetwork.priebehSluzby !== null;
    };

    const rowExpansionTemplateMobile = (vykazStreetwork: VykazStreetwork) => {
        return (
            <XHtmlRenderer htmlValue={vykazStreetwork.priebehSluzby} renderType={multilineSwitchValue} fewLinesCount={2}/>
        );
    };

    const onSaveOrCancel: XOnSaveOrCancelProp = XUtils.onSaveOrCancelNavigator(props.openForm!, xLazyDataTableRef);

    const onAddRow = () => {

        // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
        props.openForm!(<VykazStreetworkHlavickaForm onSaveOrCancel={onSaveOrCancel}/>);
    }

    const onEdit = (selectedRow: any) => {

        // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
        props.openForm!(<VykazStreetworkHlavickaForm id={selectedRow.id} onSaveOrCancel={onSaveOrCancel}/>);
    }

    // tieto 2 funkcie (velky formular aj so zapismi) tu mozno budu docasne

    // const onPridatSoZapismi = () => {
    //
    //     // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
    //     props.openForm!(<VykazStreetworkForm onSaveOrCancel={onSaveOrCancel}/>);
    // }
    //
    // const onUpravitSoZapismi = (selectedRow: VykazStreetwork) => {
    //
    //     // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
    //     props.openForm!(<VykazStreetworkForm id={selectedRow.id} onSaveOrCancel={onSaveOrCancel}/>);
    // }

    const renderDesktop = () => {

        return (
            <XLazyDataTable ref={xLazyDataTableRef} entity="VykazStreetwork" label="Denník"
                            sortField={[{field: "datum", order: -1}, {field: "id", order: -1}]} rows={30}
                            multilineSwitch={true}
                            onAddRow={onAddRow} onEdit={onEdit} removeRow={true}
                            /*
                            appButtons={[<XButton key="pridat-so-zapismi" label="Pridať aj so zápismi"
                                                  onClick={onPridatSoZapismi}/>]}
                            appButtonsForRow={[{
                                key: "upravit-so-zapismi",
                                label: "Upraviť aj so zápismi",
                                onClick: onUpravitSoZapismi
                            }]}
                            */
                            searchBrowseParams={props.searchBrowseParams}>
                <XLazyColumn field="id" header="ID" width="5rem" columnViewStatus={Utils.isUserAdmin()}/>
                <XLazyColumn field="datum" header="Dátum" betweenFilter="column"/>
                <XLazyColumn field="vykazXUserList.xUser.name" header="Pracovníci" width="12rem"/>
                <XLazyColumn field="priebehSluzby" header="Priebeh služby" width="66rem" contentType="html"/>
                <XLazyColumn field="kilometre" header="Km" width="4rem" align="right"/>
                <XLazyColumn field="hodinyCelkovo" header="Hod celk." width="6.5rem" align="right"/>
                <XLazyColumn field="hodinyVTerene" header="Hod terén" width="6.5rem" align="right"/>
            </XLazyDataTable>
        );
    }

    const renderMobile = () => {

        // width="calc(100vw - ?rem)" nefunguje, XLazyDataTable alebo DataTable nam to meni na calc(100vw)
        const tableWidth: number = XUtils.getViewWidth() - XUtils.toPX0("1rem"); // 1rem - okraje
        const columnPracovniciWidth: number = tableWidth - XUtils.toPX0("7.25rem") - XUtils.toPX0("2.5rem") - XUtils.toPX0("3rem") * 2; // stlpec Datum, stlpce Km, Celk., Teren

        return (
            <XLazyDataTable ref={xLazyDataTableRef} entity="VykazStreetwork" label="Denník" labelStyle={{marginRight: '0rem'}}
                            sortField={[{field: "datum", order: -1}, {field: "id", order: -1}]} rows={30}
                            showExpandedRow={showExpandedRowMobile} rowExpansionTemplate={rowExpansionTemplateMobile}
                            onAddRow={onAddRow} onEdit={onEdit} removeRow={true}
                            multilineSwitch={true} multilineSwitchValue={[multilineSwitchValue, setMultilineSwitchValue]}
                            searchBrowseParams={props.searchBrowseParams}>
                <XLazyColumn field="datum" header="Dátum" width="7.25rem" autoFilter={true}/>
                <XLazyColumn field="vykazXUserList.xUser.name" header="Pracovníci" width={`${columnPracovniciWidth}px`}/>
                <XLazyColumn field="kilometre" header="Km" width="2.5rem"/>
                <XLazyColumn field="hodinyCelkovo" header="Celk." width="3rem"/>
                <XLazyColumn field="hodinyVTerene" header="Terén" width="3rem"/>
            </XLazyDataTable>
        );
    }

    if (!XUtils.isMobile()) {
        return renderDesktop();
    }
    else {
        return renderMobile();
    }
}
